import BubbleUpsellPattern from '@assets/illustration/BubbleUpsellPattern';
import { Button } from 'geniebook-ui/dist';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-solid-svg-icons/faLock';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import { ButtonSize } from 'geniebook-ui/dist/components/Button/variant';
import { useViewWidth } from '@utils/helpers/viewWidth';
import { useSetAtom } from 'jotai';
import { showUnlockTrialPopUpAtom } from '@atom/popUpAtom';
import globalStore from '@store/globalStore';

const breakpoint = require('geniebook-ui/dist/themes/breakpoint');

const LeaderboardUpsellingBanner = () => {
  const setUnlockTrialPopUp = useSetAtom(showUnlockTrialPopUpAtom, {
    store: globalStore,
  });
  const width = useViewWidth();

  const buttonProperties = {
    size: (width < breakpoint.md ? 'sm' : 'md') as ButtonSize,
    width: width >= breakpoint.lg ? '211px' : '175px',
    height: width <= breakpoint.sm ? '34px' : '46px',
    padding: width >= breakpoint.lg ? '9px' : '0px',
  };

  return (
    <div
      className={
        'rounded-t-[16px] bg-gradient-to-r from-[#3F39A2] to-[#19A2C0] sticky bottom-0 max-sm:h-[101px] h-[86px] px-[24px] pt-[16px] pb-[24px] max-sm:flex-col md:flex shadow-[0px_0px_24px_0px_rgba(255,255,255,0.20)]'
      }
    >
      <BubbleUpsellPattern className={'absolute right-0 z-0 top-0 h-[100%]'} />
      <div className={'flex z-1'}>
        <div
          className={
            'md:mr-[16px] mx-[0px] mb-0 min-sm:pt-[8px] max-md:flex md:inline-flex min-lg:float-right max-md:float-left max-lg:flex-col max-sm:w-full sm:w-2/3 min-xl:w-1/2 md:flex-row md:flex-wrap md:content-center md:justify-end md:ml-[14px]'
          }
        >
          <div className={'relative'}>
            <h3
              className={
                "inline-flex max-sm:text-[14px] min-md:text-[16px] font-extrabold font-['Open_Sans'] leading-snug w-full"
              }
            >
              Need a boost on the leaderboard?
            </h3>
            <p
              className={
                "inline-flex text-sm font-normal font-['Open_Sans'] leading-[19px] w-full max-sm:w-1/2"
              }
            >
              Buy an additional subject to unlock more Bubbles.
              <div className={'max-sm:block max-sm:w-1/2 ml-[16px] sm:hidden'}>
                <Button
                  className={`!w-[124px] !font-extrabold !py-[12px] !px-[24px] !h-[34px] mt-[5px] float-right`}
                  variant="primary"
                  size={buttonProperties.size}
                  onClick={() => setUnlockTrialPopUp(true)}
                >
                  <FontAwesomeIcon icon={faLock as IconDefinition} />
                  &nbsp;Unlock{width < breakpoint.md ? '' : ' free trial'}
                </Button>
              </div>
            </p>
          </div>
        </div>
        <div
          className={
            'max-sm:hidden max-md:flex max-md:pt-[4px] md:flex-wrap max-md:flex-col md:flex-row max-sm:w-full sm:w-1/3 min-xl:w-1/2 flex-wrap md:content-center justify-end'
          }
        >
          <Button
            className={`!w-[${buttonProperties.width}] !font-extrabold !py-[12px] !px-[24px] !h-[${buttonProperties.height}]`}
            variant="primary"
            size={buttonProperties.size}
            onClick={() => setUnlockTrialPopUp(true)}
          >
            <FontAwesomeIcon icon={faLock as IconDefinition} />
            &nbsp;Unlock{width < breakpoint.sm ? '' : ' free trial'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LeaderboardUpsellingBanner;
